export const translationFR = {
  top: {
    text_1: 'Des aliments frais et une planète meilleure',
    text_2: 'DES MILLIERS',
    text_3: 'DE RECETTES',
    text_4: 'Un endroit pour vous aider à gérer vos ingrédients',
    text_5: 'Recettes de nombreuses cuisines',
    text_6: 'Menus hebdomadaires, liste de courses',
  },
  main_function: {
    text_1: 'Fonctions principales',
    text_1_1: 'Gardez vos aliments frais !',
    text_1_2: 'Recevez des alertes de notre vérificateur de fraîcheur pour éviter de gaspiller de la nourriture',
    text_2_1: 'Suggestions de recettes IA',
    text_2_2:
      'Découvrez des recettes de nombreuses cuisines dans le monde en fonction des ingrédients restants dans votre réfrigérateur',
    text_3_1: 'Menus pour toute la semaine',
    text_3_2: 'Créez des menus pour toute la semaine',
    text_4_1: 'Liste de courses',
    text_4_2: 'Créez et mettez à jour vos listes de courses pour être prêt pour vos achats',
    text_5: 'Télécharger',
    text_6: 'iFridge vous aidera',
    text_7_1: 'À devenir une meilleure ménagère',
    text_7_2: 'À réduire les déchets et à rendre la planète plus saine',
    text_7_3: 'À aimer cuisiner',
  },
  rate_box: {
    text_1: 'Avis des utilisateurs',
  },
  faqs: {
    text_1: 'FAQ',
    text_2_1: 'Quels types de comptes existe-t-il ? Puis-je utiliser l’application gratuitement ?',
    text_2_2: `Vous avez le premier mois pour utiliser toutes les fonctions de l'application gratuitement et sans publicité.
      <br /><br />Après le premier mois, votre compte deviendra automatiquement un COMPTE GRATUIT.
      <br /><br />Avec un COMPTE GRATUIT, vous pouvez utiliser les fonctions de base de l'application comme : gestion des ingrédients, rapport quotidien sur l'état des ingrédients. Vous ne pourrez pas utiliser certaines fonctions avancées comme : suggestions de recettes IA, menus hebdomadaires, liste de courses. Des publicités apparaîtront également lors de l'utilisation de l'application.
      <br /><br />Pour utiliser toutes les fonctions de l'application sans publicité, vous devez passer à un COMPTE PREMIUM, avec un coût mensuel très raisonnable.`,
    text_3_1: 'Combien coûte un COMPTE PREMIUM ?',
    text_3_2: `Vous pouvez vous abonner mensuellement ou annuellement.
      <br /><br />Coût mensuel : 0,99 $/mois.
      <br /><br />Coût annuel : 9,99 $/an.
      <br /><br />Il n'y a pas d'autres frais.`,
    text_4_1: 'Puis-je m’abonner à un COMPTE PREMIUM sans payer ?',
    text_4_2: `Oui, absolument.
      <br /><br />Pour souscrire à un COMPTE PREMIUM, vous pouvez utiliser des Points iFridge.
      <br /><br />Les Points iFridge peuvent être achetés via l'App Store/Google Play : sur l'écran des paramètres, appuyez sur le menu Points qui vous mènera à l'écran d'achat de points.
      <br /><br />Ou vous pouvez gagner des Points iFridge en regardant des publicités : sur l'écran des paramètres, appuyez sur le menu Autres paramètres, puis sur Regarder des publicités.`,
    text_5_1: 'Est-ce que je gagne des Points iFridge en regardant des publicités ?',
    text_5_2: `Vous pouvez gagner des Points iFridge en regardant des publicités.
      <br /><br />Selon votre pays, vous recevrez un certain nombre de Points iFridge pour chaque publicité visionnée (selon les règlements de Google Admob). Après avoir visionné une publicité, vous devez attendre 20 minutes avant de pouvoir visionner la suivante.`,
    text_6_1: 'Puis-je gagner des Points iFridge en parrainant des amis ?',
    text_6_2: `Oui, absolument, vous pouvez gagner des Points iFridge en parrainant des amis.
      <br /><br />Selon votre pays, vous pouvez obtenir un certain nombre de Points iFridge en partageant des informations sur iFridge sur des réseaux sociaux comme Facebook, Twitter, etc.
      <br /><br />En un mois, vous pouvez recevoir des Points iFridge une seule fois pour vos parrainages.`,
    text_7_1: 'Mes données personnelles sont-elles sécurisées ? Sont-elles partagées avec des tiers ?',
    text_7_2:
      'Vos données sont entièrement stockées sur votre téléphone et totalement sécurisées. Nous ne stockons pas vos données personnelles sur nos serveurs et nous ne les partageons pas avec des tiers.',
    text_8_1: 'Si j’ai besoin d’aide, comment puis-je contacter le support ?',
    text_8_2: `Vous pouvez nous contacter via la fonction Contactez-nous : sur l'écran des paramètres, sélectionnez Autres paramètres, puis Contactez-nous.
      <br /><br />Ou envoyez vos demandes d’assistance/commentaires directement par email à : ifridge.foodie@gmail.com`,
  },
  footer: {
    text_1: 'L’amour peut aller et venir,',
    text_2: 'mais la faim frappe tous les jours',
  },
};
